export * from './DeliveryMinimumAmountAlert.ui';
